function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLmsEditSquareComplete = function SvgLmsEditSquareComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.047 2.57 1.375 1.376c.77.761.77 2 0 2.76l-1.034 1.035-4.136-4.136 1.034-1.034c.76-.761 2-.761 2.76 0ZM13 18v-.1l6.559-6.56v8.711a1.957 1.957 0 0 1-1.951 1.951h-5.864A6.967 6.967 0 0 0 13 18Zm-6.895-7 6.557-6.557H3.951A1.957 1.957 0 0 0 2 6.394v5.86a6.968 6.968 0 0 1 4.105-1.253Zm2.327.434a7.02 7.02 0 0 1 4.135 4.137l6.446-6.445-4.137-4.136-6.444 6.444ZM0 18c0-3.312 2.688-6 6-6s6 2.688 6 6-2.688 6-6 6-6-2.688-6-6Zm1.8 0 3 3 5.4-5.4-.846-.852L4.8 19.302l-2.154-2.148L1.8 18Z",
    fill: "currentColor"
  }));
};
export default SvgLmsEditSquareComplete;